function ArrivingTodayIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={16} cy={16} r={16} fill="#E94BA7" />
      <path
        d="M25 20.802V21.04H7.427v-.006-.232s-.038-1.378 1.706-1.337h14.16C25.038 19.424 25 20.802 25 20.802zM23.213 16.96c-.295-2.233-1.382-4.013-3.4-5.19-.98-.573-1.965-.915-2.944-1.028v-.82c.209.001.413.018.611-.005.152-.017.316-.056.443-.136.242-.15.33-.461.247-.73a.642.642 0 00-.602-.46c-.616-.01-1.231-.006-1.847-.006-.317 0-.634-.006-.95.008a.636.636 0 00-.608.632c-.012.399.27.684.697.697.213.006.427 0 .635 0v.812c-1.192.124-2.366.592-3.505 1.4-1.687 1.198-2.601 2.845-2.848 4.83a.846.846 0 00.22 1.662h13.64a.846.846 0 00.211-1.665z"
        fill="#fff"
      />
    </svg>
  )
}

export default ArrivingTodayIcon
